const trackGTMDataLayer = () => {
  return null
}

export { trackGTMDataLayer }
